import React from 'react';
import { Link, LinkProps } from '@mui/material';

const LinkNoPropagate: React.FC<React.PropsWithChildren<LinkProps>> = (props) => {
  const noPropagation = (e: React.MouseEvent<HTMLSpanElement>) => e.stopPropagation();
  return <Link {...props} onClick={noPropagation} />;
};

export default LinkNoPropagate;
